import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";

const DarkTheme = () => {
  const [darkThemeEnable, setDarkThemeEnable] = useState(false);

  const handleToggle = () => {
    setDarkThemeEnable(prevState => !prevState);
  };

  useEffect(() => {
    const logDarkThemeStatus = (status) => {
      console.log("Dark theme enabled:", status);
    };
    logDarkThemeStatus(darkThemeEnable);
  }, [darkThemeEnable]);

  return (
    <>
      <div className="p-3">
        <Button
          variant="outline-primary"
          className="mb-2 d-flex  align-items-end"
        >
          Import from Theme H preset into this section
        </Button>
        <div className="row row-cols-1 row-cols-md-2">
          <div className="col">
            <div className="d-flex flex-column gap-2">
              <Form.Label className="mb-0">
                Enable Dark Theme Toggle
              </Form.Label>
              <Form.Text className="mb-0">
                Enable Dark Theme Toggle Displays a toggle inside the Profile
                top right menu which let user to switch theme to Dark and vice
                versa.
              </Form.Text>
              <Form.Check
                type="switch"
                id="darkThemeToggle"
                name="darkThemeToggle"
                checked={darkThemeEnable}
                onChange={handleToggle}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DarkTheme;
